import { render, staticRenderFns } from "./ArticlesPage.vue?vue&type=template&id=5f80199d"
import script from "./ArticlesPage.vue?vue&type=script&lang=js"
export * from "./ArticlesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports